export default __webpack_public_path__ + "static/media/switch_arrow.c468c60c.svg";